import { RegistrationResult } from './../../models/RegistrationResult';
import { HTTP_HELPER } from './../../providers/http.helper.provider';
import { Captcha } from './../../models/Captcha';
import { EventService } from 'src/app/services/event.service';
import { environment } from './../../../environments/environment';
import { FinalizeRegistrationRequest } from './../../models/FinalizeRegistrationRequest';
import { Sponsorship } from '../../models/Sponsorship';
import { Speaker } from '../../models/Speaker';
import { SessionTrack } from '../../models/SessionTrack';
import { Session } from '../../models/Session';
import { Pass } from '../../models/Pass';
import { HttpHelper } from '../../helpers/HttpHelper';
import { Injectable, Inject } from '@angular/core';
import { Event } from '../../models/Event';
import { Observable } from 'rxjs';
import { RegistrationData } from '../../models/RegistrationData';
import * as CustomRegistrationFieldModel from '../../models/CustomRegistrationField';

@Injectable()
export class EventRestService implements EventService {
    private static readonly eventsEndpoint: string = 'events';

    constructor(@Inject(HTTP_HELPER) private http: HttpHelper) {
    }

    public getPublishedEvents(): Observable<Event[]> {
        // console.log("event.rest.service - getPublishedEvents");
        const url = `${environment.apiEndpoint_PROXY}/?mode=events-published`;
        return this.http.get<Event[]>(url);
    }

    public getEvent(readableEventId: string): Observable<Event> {
        // console.log("event.rest.service - getEvent");
        return this.http.get<Event>(
            `${environment.apiEndpoint_PROXY}/?mode=event&eventId=${readableEventId}`
        );
    }

    public getPasses(readableEventId: string): Observable<Pass[]> {
        // console.log("event.rest.service - getPasses");
        return this.http.get<Pass[]>(
            `${environment.apiEndpoint_PROXY}/?mode=event-passes&eventId=${readableEventId}`
        );
    }

    public getSessions(readableEventId: string): Observable<Session[]> {
        // console.log("event.rest.service - getSessions");
        return this.http.get<Session[]>(
            `${environment.apiEndpoint_PROXY}/?mode=event-sessions&eventId=${readableEventId}`
        );
    }

    public getSessionTracks(readableEventId: string): Observable<SessionTrack[]> {
        // console.log("event.rest.service - getSessionTracks");
        return this.http.get<SessionTrack[]>(
            `${environment.apiEndpoint_PROXY}/?mode=event-tracks&eventId=${readableEventId}`
        );
    }

    public getSpeakers(readableEventId: string): Observable<Speaker[]> {
        // console.log("event.rest.service - getSpeakers");
        return this.http.get<Speaker[]>(
            `${environment.apiEndpoint_PROXY}/?mode=event-speakers&eventId=${readableEventId}`
        );
    }

    public getSponsors(readableEventId: string): Observable<Sponsorship[]> {
        // console.log("event.rest.service - getSponsors");
        return this.http.get<Sponsorship[]>(
            `${environment.apiEndpoint_PROXY}/?mode=event-sponsors&eventId=${readableEventId}`
        );
    }

    public getCaptcha(readableEventId: string): Observable<Captcha> {
        // console.log("event.rest.service - getCaptcha");
        return this.http.get<Captcha>(`${environment.apiEndpoint_PROXY}/?mode=event-captcha&eventId=${readableEventId}`);
    }

    public getCustomRegistrationFields(readableEventId: string): Observable<CustomRegistrationFieldModel.CustomRegistrationField[]> {
        // console.log("event.rest.service - getCustomRegistrationFields");
        const url = `${environment.apiEndpoint_PROXY}/?mode=event-customregistrationfields&eventId=${readableEventId}`;
        return this.http.get<CustomRegistrationFieldModel.CustomRegistrationField[]>(url);
    }

    public getEventRegistrationCount(readableEventId: string): Observable<number> {
        // console.log("event.rest.service - getEventRegistrationCount");
        return this.http.get<number>(
            `${environment.apiEndpoint_PROXY}/?mode=event-registrationcount&eventId=${readableEventId}`
        );
    }

    public registerToEvent(readableEventId: string, registrationData: RegistrationData): Observable<RegistrationResult> {
        // console.log("event.rest.service - registerToEvent");
        const url = `${environment.apiEndpoint_PROXY}/?mode=event-registration&eventId=${readableEventId}`;
        return this.http.post<RegistrationResult>(url, registrationData, true);
    }

    public finalizeRegistration(readableEventId: string, requestData: FinalizeRegistrationRequest): Observable<RegistrationResult> {
        // console.log("event.rest.service - finalizeRegistration");
        const url = `${environment.apiEndpoint_PROXY}/?mode=event-registration-finalize&eventId=${readableEventId}`;
        return this.http.post<RegistrationResult>(url, requestData, true);
    }

    public registerToSession(readableEventId: string, sessionId: string): Observable<boolean> {
        // console.log("event.rest.service - finalizeRegistration");
        const url = `${environment.apiEndpoint_PROXY}/?mode=event-registertosession&eventId=${readableEventId}`;
        const body= {'readableEventId': readableEventId,'sessionId': sessionId};
        return this.http.post<boolean>(url,body);
    }
}
